import Tasks from 'APP/Tasks';
import { createScheduledGroup } from 'APP/Tasks/group/loadScheduledMessages/loadScheduledMessages';
import { UpdateReason } from 'APP/constants/scroll';
import { IScheduledMessage } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';
import { Payload } from 'STORE/Messages/Message/Payload/Payload';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

import { getScheduledMessageData } from './getScheduledMessageData';
import { sendScheduledMessage } from './sendScheduledMessage';

interface IMessageData {
  payload: Payload;
  scheduleTime: number;
  clientUuid?: string;
  repliedMessage?: ChatMessage;
  quote?: Quote;
}

export async function createScheduledMessage(
  groupId: string,
  messageData: IMessageData
): Promise<boolean> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return false;
  }

  let scheduledGroup = Entities.GroupsStore.getGroupById(group.scheduleGroupId);
  if (!scheduledGroup) {
    scheduledGroup = createScheduledGroup(group);
    if (!scheduledGroup) {
      return false;
    }
  }

  const data = getScheduledMessageData({
    groupId,
    payload: messageData.payload,
    scheduleTime: messageData.scheduleTime,
    clientUuid: messageData.clientUuid,
    repliedMessage: messageData.repliedMessage,
    quote: messageData.quote,
  });

  // TODO: привести в порядок messageModel.types
  Tasks.messaging.updateScheduledMessages(groupId, [data as unknown as IScheduledMessage]);
  Tasks.messaging.clearInputPanel(groupId);

  const message = scheduledGroup.messagesStore.getMessageById(data.id);
  if (!message) {
    return false;
  }

  if (Entities.GroupsStore.activeGroupId) {
    if (Entities.GroupsStore.activeGroupId !== groupId) {
      Tasks.messaging.clearInputPanel(Entities.GroupsStore.activeGroupId);
    }
    Entities.ChatStore.setScrollChanged(UpdateReason.ScrollToBottom, { isAnimated: true });
  }

  sendScheduledMessage({
    groupId,
    message,
    delay: data.delay,
    callback: (result: boolean): void => {
      if (!result) {
        message.setError(MessageError.Schedule);
      }
    },
  });

  return true;
}
